import React from 'react';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { hideModal } from 'cards/actions/modalActions';
import styles from './styles.module.less';

const MaxPublished = ({ onConfirm }) => {
  const onClick = () => {
    onConfirm();
    browserHistory.push('/wedding-planning/projects/digital');
  };
  return (
    <div className={styles.container}>
      <div className={styles.header}>Oops! You have published the max of 5 links</div>
      <div className={styles.content}>
        Delete one of your published links or move it to drafts to continue.
      </div>
      <div className={styles.buttonContainer}>
        <ButtonV2 onClick={onClick}>Go To Published Projects</ButtonV2>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  onConfirm: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(MaxPublished);
